import { render, staticRenderFns } from "./CodeMasterDetails.vue?vue&type=template&id=487fd9de"
import script from "./CodeMasterDetails.vue?vue&type=script&lang=js"
export * from "./CodeMasterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports